module.exports = __webpack_public_path__ + "static/media/Project-Build.a064ab04.svg";